import React, { useEffect, useState } from "react";
import "../HomeFolder/HomeSideNavbar.css";
import "./PodcastSideNavbar.css";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import { baseUrl } from "../../Constants";
import { Alert } from "@mui/material";

function getModalStyle() {
  const top = "20%";
  const left = "35%";
  return {
    top: "25%",
    left: "38%",
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = {
  disabledButton: {
    backgroundColor: "gray",
    color: "white",
    cursor: "not-allowed",
    margin: 10,
    border: "none",
    textAlign: "center",
    alignItems: "center",
  },
  enabledButton: {
    backgroundColor: "#7f9ff7",
    color: "white",
    cursor: "pointer",
    margin: 10,
    border: "none",
    textAlign: "center",
    alignItems: "center",
  },
};

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 420,
    height: "50%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: "none",
    overflowY: "auto",
    borderRadius: "0px",
    [theme.breakpoints.down("md")]: {
      height: "60% !important",
    },
  },
}));

function PodcastSideNavbar() {
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);
  const [feedbackRes, setFeedbackRes] = useState("");
  const [toggle, setToggle] = useState(true);
  const [comment, setComment] = useState("");
  const [feedbackBtn, setFeedbackBtn] = useState(true);
  const [feedbackErr, setFeedbackErr] = useState(false);
  const [taInlnStyle, setTaInlnStyle] = useState({ height: "15px" });
  const [rating, setRating] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // for mobile toggle

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    if (window.innerWidth <= 768) setIsMenuOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
    setToggle(true);
    setRating([]);
    handleLinkClick();
  };

  const handleClose = () => {
    setOpen(false);
    setToggle(false);
  };

  const handleComment = (commentVal) => {
    if (commentVal.length > 46 && commentVal.length < 92)
      setTaInlnStyle({ height: "45px" });
    else if (commentVal.length > 92) setTaInlnStyle({ height: "70px" });
    else if (commentVal.length < 46) setTaInlnStyle({ height: "21px" });
    setComment(commentVal);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const isLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";
    if (process.env.NODE_ENV === "development" || isLocalhost) {
      alert("Not allowed to submit feedback from localhost.");
      return;
    } else {
      setToggle(false);
      axios
        .post(
          `${baseUrl}/podcastFeedback`,
          {
            enterprise_id: activeAccount.idTokenClaims.enterpriseID,
            rating: rating.length,
            comment: comment,
          },
          {
            headers: {
              Authorization: localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => setFeedbackRes(response.data.message))
        .catch((error) => setFeedbackErr(error.response.data.message));
      setComment("");
    }
  };

  const isSubmitDisabled = rating.length === 0 || comment.length === 0;

  const body = (
    <div style={modalStyle} className={classes.paper} id="feedback-main-box">
      {toggle && (
        <div id="feedback_form">
          <form onSubmit={handleSubmit}>
            <div className="feedback_label">Send Feedback</div>
            <div className="feedback">
              <span id="thankYou-close" onClick={handleClose}></span>
              <h6 className="question">
                Tell us your experience with the L&TT Portal!
              </h6>
              <div className="feedback-rating">
                {[1, 2, 3, 4, 5].map((num) => (
                  <img
                    key={num}
                    src={
                      rating.includes(num)
                        ? process.env.PUBLIC_URL +
                          "/images/feedback/star_active.svg"
                        : process.env.PUBLIC_URL +
                          "/images/feedback/star_inactive.svg"
                    }
                    alt="rating"
                    onClick={() =>
                      setRating(Array.from({ length: num }, (_, i) => i + 1))
                    }
                  />
                ))}
                <p id="star-text" tabIndex="0">
                  {rating.length}/5
                </p>
              </div>
              <textarea
                onChange={(event) => handleComment(event.target.value)}
                id="feedback-input"
                type="text"
                rows="2"
                placeholder="Please provide suggestions or feedback here"
                style={taInlnStyle}
              ></textarea>
              <div className="submit">
                <button
                  type="submit"
                  style={
                    isSubmitDisabled
                      ? styles.disabledButton
                      : styles.enabledButton
                  }
                  disabled={isSubmitDisabled}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
      {!toggle && !feedbackErr && (
        <div id="success_form">
          <span id="thankYou-close" onClick={handleClose}></span>
          <h2 className="feedback-success">Thank you!</h2>
          <p className="feedback-success-msg">{feedbackRes}</p>
        </div>
      )}
      {!toggle && feedbackErr && (
        <div style={{ marginTop: "30px" }}>
          <span id="thankYou-close" onClick={handleClose}></span>
          <Alert severity="error">{feedbackErr}</Alert>
        </div>
      )}
    </div>
  );

  return (
    <div
      className={`sidebar-container podcast-sidebar-container ${
        isMenuOpen ? "menu-open" : ""
      }`}
    >
      {/* Hamburger Button */}
      <button className="hamburger-btn" onClick={toggleMenu}>
        {isMenuOpen ? "✖" : "☰"}
      </button>

      <div
        className={`podcast-sidebar-wrap ${isVisible ? "visible" : ""} ${
          isMenuOpen ? "menu-open" : ""
        }`}
      >
        <div className="sidebar-row">
          {/* Viva Engage */}
          <div className="sideimg-box box3" onClick={handleLinkClick}>
            <a
              href="https://engage.cloud.microsoft/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyMjYxMDQ2MzEyOTYifQ/new"
              target="blank"
              rel="noopener noreferrer"
            >
              <img
                src="images/Sidebar/new-icons/viva-engage-icon.png"
                alt="logo"
                className="white-icon viva-engage-icon"
              />
              <img
                src="images/Sidebar/new-icons/viva-engage-icon-hover.png"
                alt="logo"
                className="grey-icon viva-engage-icon-hover"
              />
              <p>
                Viva <br /> Engage
              </p>
            </a>
          </div>

          {/* Feedback Button */}
          {feedbackBtn && (
            <div className="sideimg-box box1" onClick={handleOpen} tabIndex={0}>
              <img
                src="images/Sidebar/new-icons/podcast-feedback-brand.png"
                alt="logo"
                className="white-icon feedback-icon"
              />
              <img
                src="images/Sidebar/new-icons/podcast-feedback-brand-hover.png"
                alt="logo"
                className="grey-icon feedback-icon-hover"
              />
              <p>Feedback</p>
            </div>
          )}

          {/* Feedback Modal */}
          <Modal
            open={open}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            {body}
          </Modal>

          {/* Disabled Ask AIVA */}
          <div className="sideimg-box box6" onClick={handleLinkClick}>
            <button
              aria-label="aiva"
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "not-allowed",
              }}
              disabled
            >
              <img
                src="images/Sidebar/new-icons/chatbot.png"
                alt="logo"
                className="white-icon chatbot-icon"
              />
              <img
                src="images/Sidebar/new-icons/chatbot.png"
                alt="logo"
                className="grey-icon chatbot-icon-hover"
              />
              <p>Ask AIVA</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PodcastSideNavbar;
